import { render, staticRenderFns } from "./test_issue_body.vue?vue&type=template&id=ea9b7a74&"
import script from "./test_issue_body.vue?vue&type=script&lang=js&"
export * from "./test_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports